module.exports = __webpack_public_path__ + "assets/img/79663a06b28fcb6f55248de5065850aa.png";